export const LEGEND_LABEL = 'Loyalty Transactions';
